var App = App || {};

App.ComponentOpenAccount = (function ($) {
    'use strict';

    let data = {};
    var initial_query_string = window.location.search;
    function isCustodialAccount(accountCode) {
        const patterns = ["utma"];
        const code = accountCode.toLowerCase();
        return patterns.some(p => code.includes(p.toLowerCase()));
    }
    function isMinorAccount(accountCode) {
        const patterns = ["minor", "joint"];
        const code = accountCode.toLowerCase();
        return patterns.some(p => code.includes(p.toLowerCase()));
    }

    function init(modal) {

        modal.on("show.bs.modal", function () {

            const pages = modal.find("[data-open-account-page]").toArray().map(p => p.dataset["openAccountPage"]);
            const values = pages.reduce((acc, key) => {
                acc[key] = "";
                return acc;
            }, {});

            data = {
                objects: {
                    modal: modal,
                    buttonNext: modal.find("[data-open-account-action=\"next\"]"),
                    buttonPrev: modal.find("[data-open-account-action=\"prev\"]"),
                },
                pages: {
                    list: pages,
                    current: pages[0],
                    prev: "",
                    next: ""
                },
                values: {
                    productType: modal[0].dataset["openAccountType"],
                    ...values
                },
                 queryString: initial_query_string
            };

            if (data.values.productType == "cd") {
                const productIdStorage = sessionStorage.getItem("OpenAccountProductId");
                const productIdVal = App.Base.GetUrlParameter("productId", productIdStorage);
                sessionStorage.removeItem("OpenAccountProductId");
                data.values.productCode = productIdVal;
            }

            FormInteract();
            FormRefresh();
        });

        modal.on("hidden.bs.modal", function () {
            modal.find("form")[0].reset();
            data = {};
        });
    }

    function FormInteract() {

        // fields
        data.objects.modal.find("input, select").off("change").on("change", function () {

            const name = $(this).attr("name");
            const value = $(this).val();
            const autoProgress = $(this).parents("[data-open-account-auto]").attr("data-open-account-auto") === "true";

            if (name === "productCode") {
                if (isCustodialAccount(value))
                    data.values.accountPurpose = "UTMA";
                else if (isMinorAccount(value))
                    data.values.accountPurpose = "MINOR";
                else
                    data.values.accountPurpose = null;
            }

            data.values[name] = value;
            FormRefresh(autoProgress);
        });

        // buttons
        data.objects.buttonNext.off("click").on("click", function () {
            data.pages.current = data.pages.next;
            data.pages.next = "";
            FormRefresh();

        });
        data.objects.buttonPrev.off("click").on("click", function () {
            data.pages.current = data.pages.prev;
            data.pages.prev = "";
            FormRefresh();
        });
    }

    function FormRefresh(autoProgress) {

        switch (data.pages.current) {

            case "submit": {
                const url = GetSubmitUrl(data);
                if (url !== null) {
                    window.open(url, "_blank");
                    data.objects.modal.modal("hide");
                }
                break;
            }

            case "productCode": {
                data.pages.prev = "";

                const productCode = data.values.productCode;
                if (productCode !== "") {
                    GtmDataLayer("productCode", productCode);
                    if (isCustodialAccount(productCode)) {

                        data.values.customerExisting = "No";
                        data.pages.next = "customerState";
                    }
                    else {
                        data.pages.next = "customerExisting";
                    }
                }
                break;
            }

            case "customerExisting": {
                if (data.pages.list[0] === "productCode") {
                    data.pages.prev = "productCode";
                }

                const val = data.values.customerExisting;
                if (val === "No") {
                    GtmDataLayer("customerExisting", val);
                    data.pages.next = "customerState";
                } else if (val === "Yes") {
                    GtmDataLayer("customerExisting", val);
                    data.pages.next = "customerOlb";
                }

                // Reset dependent fields
                data.values.customerState = "";
                data.objects.modal.find('select[name="customerState"]').val("");

                data.values.customerOlb = "";
                data.objects.modal.find('input[name="customerOlb"]').prop("checked", false);

                break;
            }

            case "customerState": {
                data.pages.prev = (isCustodialAccount(data.values.productCode))
                    ? "productCode"
                    : "customerExisting";

                const val = data.values.customerState;
                if (val !== "") {
                    GtmDataLayer("customerState", val);
                    data.pages.next = "submit";
                }

                break;
            }

            case "customerOlb": {
                data.pages.prev = "customerExisting";

                const val = data.values.customerOlb;
                if (val === "Yes") {
                    GtmDataLayer("customerOlb", val);
                    data.pages.next = "submit";
                } else if (val === "No") {
                    GtmDataLayer("customerOlb", val);
                    data.pages.next = "customerOlbEnroll";
                }

                break;
            }

            case "customerOlbEnroll": {
                data.pages.prev = "customerOlb";
                data.pages.next = "submit";
                break;
            }
        }

        data.objects.buttonNext.prop("disabled", data.pages.next === "");
        data.objects.buttonPrev.prop("disabled", data.pages.prev === "");
        data.objects.modal.find(`[data-open-account-page="${data.pages.current}"]`).slideDown(250).siblings("[data-open-account-page]").slideUp(250);

        if (autoProgress) {
            data.objects.buttonNext.trigger("click");
        }
    }

    function GetSubmitUrl() {

        if (data.values.customerOlb === "No") {
            GtmDataLayer("enrollOLB", "continue");
            return "https://secure.applebankdirectonline.com/applebankonline/uux.aspx#/unauth/extension/EnrollmentFlow/Main";
        }

        GtmDataLayer("startApplication", "continue");

        const params = {
            productCode: data.values.productCode,
            accountPurpose: data.values.accountPurpose,
            IsExistingApplicant: data.values.customerExisting
        };

        const baseQuery = Object.entries(params)
            .filter(([_, v]) => v !== null && v !== "" && v !== undefined)
            .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
            .join("&");

        let finalQuery = baseQuery;

         if (data.queryString) {

            const urlParams = new URLSearchParams(data.queryString);
            let hasPromoCode = false;

            for (const key of urlParams.keys()) {
                if (key.toLowerCase() === "promotioncode" || key.toLowerCase() === "gclid") {
                    hasPromoCode = true;
                    break;
                }
            }

            if (hasPromoCode) {
                const cleaned = data.queryString.substring(1); // remove "?"
                finalQuery = baseQuery
                    ? `${baseQuery}&${cleaned}`
                    : cleaned;
            }
        }

        return `https://apply.applebank.com/?${finalQuery}`;
    }

    function GtmDataLayer(modalStep, modalValue) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'accountModal',
            'modalStep': modalStep,
            'modalValue': modalValue,
        });
    }

    return {
        init: init,
        GtmDataLayer: GtmDataLayer
    };

})(jQuery);

$(function () {
    $(".component-open-account").each(function () {
        App.ComponentOpenAccount.init($(this));
    });
});
